import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import AppManager from "../../managers/AppManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import {
    DKLabel,
    DKInput,
    DKIcon,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import PerformaceService from "../../services/PerformaceService";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { useTranslation } from "react-i18next";
import ic_no_data from "../../assets/icons/ic_no_data_3.png";
import moment from "moment";
import { DATE_FORMAT } from "../../constants/Constant";
import ProgressBar from "@ramonak/react-progress-bar";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { AssessmentReviewColumnConfig, isValidReviwer, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import { TableManger, TABLES } from "../../managers/TableManger";
import { TENANT, TenantService } from "../../managers/TenantManagerService";

function AssessmentReview(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const [count, updateCount] = useState(1);
    const [activeCycle, setActiveCycle] = useState(-1);
    const [assessmentPeriod, setAssessmentPeriod] = useState(null);
    const [assessmentPeriodOptions, setAssessmentPeriodOptions] = useState([]);
    const [assessmentReviews, setAssessmentReviews] = useState(-1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [employeeCount, setEmployeeCount] = useState(0);
    const [selfAssessmentPercent, setSelfAssessmentPercent] = useState(0);
    const [appraiserAssessmentPercent, setAppraiserAssessmentPercent] = useState(0);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        window.navigateToAdminReview = (assessment) => {
            const jsonAssessmentObj = Utility.decodeJSON(assessment);
            if(!isValidReviwer(jsonAssessmentObj)) {
                return;
            } else {
                PerformaceService.ASSESSMENT = jsonAssessmentObj
                RouteManager.navigateToPage(PAGE_ROUTES.ADMIN_REVIEW);
            }
        }

        getAppraisalCycle();

        return () => {
            window.navigateToAdminReview = null;
        }
    }, []);

    useEffect(() => {
        if (assessmentPeriod) {
            getAppraisalReviews();
        }
    }, [assessmentPeriod, currentPage]);

    const forceUpdate = () => {
        updateCount(count + 1);
    }

    const getDropdownValue = (v, o) => {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index].value;
        }

        return value;
    }
    const getAppraisalCycleLabel = (assPeriod) => {
        return `${!Utility.isEmpty(assPeriod.name) ? assPeriod.name:""} (${moment(assPeriod.startDate, DATE_FORMAT.IND).format("DD MMMM YYYY")} - ${moment(assPeriod.endDate, DATE_FORMAT.IND).format("DD MMMM YYYY")})`
    }
    const buildAssessmentPeriodOptions = (assessmentPeriodList) => {
        const options = assessmentPeriodList.map((assPeriod) => {
            return {
                value: assPeriod.id,
                label: getAppraisalCycleLabel(assPeriod),
                data: assPeriod
            };
        });

        setAssessmentPeriodOptions(options);

        if (options?.length > 0) {
            setAssessmentPeriod(options[0]);
        }
    }

    const getAppraisalCycle = () => {
        (
            TenantService.get(TENANT.APPRAISAL_REPORTING_MANAGER) && 
            !TenantService.get(TENANT.IS_ADMIN)
            ? 
            PerformaceService.getReviewerAppraisalCycle() :
            PerformaceService.getAppraisalCycle()

        ).then(
            (response) => {
                if (response?.length > 0) {
                    buildAssessmentPeriodOptions(response);

                    const activeCycle = response.find((c) => c.active);
                    if (activeCycle) {
                        setActiveCycle(activeCycle);
                    } else {
                        setActiveCycle(null);
                    }
                } else {
                    setActiveCycle(null);
                }
            }, (error) => {
                setActiveCycle(null);
            }
        );
    }

    const prepareAssessmentReviewData = (assessmentReviews) => {
        if (assessmentReviews?.length > 0) {
            const rowData = AssessmentReviewColumnConfig(assessmentReviews);
            const columnConfig = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_ASSESSMENT_REVIEW), TABLES.PEOPLE_ASSESSMENT_REVIEW, {}));
    
            const assessmentReviewsData = {
                columnData: deepClone(columnConfig),
                rowData: rowData,
                filter: [],
                originalData: rowData
            };
    
            setAssessmentReviews(assessmentReviewsData);
            forceUpdate();
        } else {
            const assessmentReviewsData = {
                columnData: [],
                rowData: [],
                filter: [],
                originalData: []
            };
            setAssessmentReviews(assessmentReviewsData);
        }
    }

    const getAppraisalReviews = () => {
        const params = {
            page: currentPage - 1,
            limit: 20,
            sort: "appraiseeSubmitted",
            sortDir: "asc",
            query: `appraisal.id=${getDropdownValue(assessmentPeriod?.label, assessmentPeriodOptions)}`
        }

        const timeout = showDelayedLoader();
        PerformaceService.getAppraisalReviews(params).then(
            (response) => {
                removeDelayedLoader(timeout);
                if (response) {
                    setEmployeeCount(response.totalElements);
                    setTotalPageCount(response.totalPages);
                    setSelfAssessmentPercent(getPercent(response.selfAssementCount, response.totalElements));
                    setAppraiserAssessmentPercent(getPercent(response.appraiserProgressCount, response.totalElements));
    
                    if (response.assesmentReviewDto.length > 0) {
                        prepareAssessmentReviewData(response.assesmentReviewDto);
                    } else {
                        prepareAssessmentReviewData([]);
                    }
                } else {
                    setEmployeeCount(0);
                    setTotalPageCount(0);
                    setSelfAssessmentPercent(getPercent(0, 0));
                    setAppraiserAssessmentPercent(getPercent(0, 0));
                    prepareAssessmentReviewData([]);    
                }
            }, (error) => {
                removeDelayedLoader(timeout);
                setEmployeeCount(0);
                setTotalPageCount(0);
                setSelfAssessmentPercent(getPercent(0, 0));
                setAppraiserAssessmentPercent(getPercent(0, 0));
                prepareAssessmentReviewData([]);
            }
        );
    }

    const getPercent = (count, total) => {
        const percent = (count / total) * 100;
        return !isNaN(percent) ? percent.toFixed(2) : 0;
    }

    const renderReviewGrid = () => {
        return (
            <div className="mt-l">
                <DataGridHolderPayroll
                    tableName={"ABCD"}
                    allowBulkOperation={false}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowColumnAdd={false}
                    allowRowAdd={false}
                    allowColumnSort={false}
                    refresh={false}
                    allowDataExport={false}
                    allowRowEdit={false}
                    showContextEdit={false}
                    isActionEnabled={false}
                    gridData={assessmentReviews}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    onRowClick={(data) => {
                        const rowData = data?.rowData?.data;
                        if (rowData && rowData.appraiseeSubmissionStatus && rowData.appraiserSubmissionStatus && isValidReviwer(rowData)) {
                            PerformaceService.ASSESSMENT = rowData;
                            RouteManager.navigateToPage(PAGE_ROUTES.ADMIN_REVIEW);
                        }
                    }}
                    onPaginationClick={(requestedPageNumber) => {
                        setCurrentPage(requestedPageNumber);
                    }}
                    hideTableName={{ hidden: true }}
                />
            </div>
        );
    }

    const renderAssessmentReviews = () => {
        return (
            <div className="mt-xxl">
                <DKLabel text={t("ASSIGNED_REVIEW")} className="fs-m fw-b" />
                <DKLabel text={t("ASSIGNED_REVIEW_TEXT")} className="fs-s fw-m text-gray" />
                <div className="row mt-xl align-items-start">
                    <div style={{ flex: "0 0 30%", maxWidth: "30%" }}>
                        <div style={{ flex: "0 0 100%", maxWidth: "70%" }}>
                            <DKInput
                                title={t("ASSESSMENT_PERIOD")}
                                type={INPUT_TYPE.DROPDOWN}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                formatter={(obj) => {
                                    /** How to render a selected option in case of object **/
                                    return obj.label;
                                }}
                                  
                                dropdownConfig={{
                                    data: assessmentPeriodOptions,
                                    renderer: (i, item) => item.label,
                                    onSelect: (i, value) => {
                                        setAssessmentPeriod(value);
                                        forceUpdate();
                                    },
                                }}
                                value={assessmentPeriod}
                                onChange={() => { }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: "0 0 20%", maxWidth: "20%" }}>
                        <DKLabel text={t("EMPLOYEES")} className="text-gray" />
                        <DKLabel text={employeeCount} className="fs-m fw-b mt-l" />
                    </div>
                    <div style={{ flex: "0 0 25%", maxWidth: "25%" }}>
                        <DKLabel text={t("SELF_PROGRESS")} className="text-gray" />
                        <DKLabel text={`${selfAssessmentPercent}%`} className="fs-m fw-b m-v-s" />
                        <ProgressBar
                            completed={selfAssessmentPercent}
                            baseBgColor="#FDEDD4"
                            bgColor="#f6a625"
                            borderRadius="0"
                            isLabelVisible={false}
                            height="5px"
                            width={"60%"}
                        />
                    </div>
                    <div style={{ flex: "0 0 25%", maxWidth: "25%" }}>
                        <DKLabel text={t("APPRAISER_PROGRESS")} className="text-gray" />
                        <DKLabel text={`${appraiserAssessmentPercent}%`} className="fs-m fw-b m-v-s" />
                        <ProgressBar
                            completed={appraiserAssessmentPercent}
                            baseBgColor="#CCEFFE"
                            bgColor="#38B0FE"
                            borderRadius="0"
                            isLabelVisible={false}
                            height="5px"
                            width="60%"
                        />
                    </div>
                </div>
                {assessmentReviews !== -1 && <Fragment>
                    {assessmentReviews?.rowData?.length > 0 ? renderReviewGrid() : renderNoAssessmentReview()}
                </Fragment>}
            </div>
        );
    }

    const renderNoAssessmentReview = () => {
        return (
            <div className="row justify-content-center">
                <div className="column align-items-center position-absolute" style={{ top: "30%", pointerEvents: "none" }}>
                    <DKIcon
                        src={ic_no_data}
                        className="ic-l"
                        style={{ opacity: 0.2, marginTop: 70 }}
                    />
                    <DKLabel text={t("NO_REVIEW")} className="fw-m mt-m text-align-center" />
                </div>
            </div>
        );
    }

    return (
        <div className="parent-width">
            <div className="row">
                <DKLabel text={t("REVIEWS")} className="fs-l fw-b" />
            </div>
            {activeCycle !== -1 && <Fragment>
                {activeCycle ? renderAssessmentReviews() : renderNoAssessmentReview()}
            </Fragment>}
        </div>
    );
}

export default AssessmentReview;
